// src/AppRoutes.js
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { isTokenExpired } from '../utils';
//comment 2025-06-19

import HomePage from '../pages/Home';
import ProductPage from '../pages/Product';
import LoginPage from '../pages/Login';
import SearchPage from '../pages/Search';
import ContactUsPage from '../pages/Contactus';
import AboutUsPage from '../pages/Aboutus';
import AccessibilityPage from '../pages/Accessibility';
import FaqPage from '../pages/Faq';
import CartPage from '../pages/Cart';
import CheckoutPage from '../pages/Checkout';
import FavoritesPage from '../pages/Favorites';

import MyAccountPage from '../pages/MyAccount';
import RegisterPage from '../pages/Register';
import ForgotPasswordPage from '../pages/ForgotPassword';
import ResetPasswordPage from '../pages/ResetPassword';
import OrderDetailPage from '../pages/OrderDetail';
import { useDispatch, useSelector } from 'react-redux';
import { initUserInfo } from '../redux/userInfo';
import ECatalogPage from '../pages/ECatalog';
import BrandsPage from '../pages/Brands';
import ShopByPage from '../pages/ShopBy';

const AppRoutes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state.userInfo);

  // Define public routes that don't require authentication
  const publicRoutes = [
    '/',
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/e-catalog',
    '/shopby',
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    const currentPath = location.pathname;

    // Allow access to public routes even without authentication
    if (publicRoutes.includes(currentPath)) {
      return;
    }

    if (isTokenExpired(token)) {
      localStorage.removeItem('token');
      dispatch(initUserInfo());
      navigate('/');
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/product' element={<ProductPage />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/search' element={<SearchPage />} />
      <Route path='/contactus' element={<ContactUsPage />} />
      <Route path='/aboutus' element={<AboutUsPage />} />
      <Route path='/accessibility' element={<AccessibilityPage />} />
      <Route path='/faq' element={<FaqPage />} />
      <Route path='/myaccount/:page' element={<MyAccountPage />} />
      <Route path='/myaccount' element={<MyAccountPage />} />
      <Route path='/cart' element={<CartPage />} />
      <Route path='/checkout' element={<CheckoutPage />} />
      <Route path='/favorites' element={<FavoritesPage />} />
      <Route path='/brands' element={<BrandsPage />} />
      <Route path='/register' element={<RegisterPage />} />
      <Route path='/forgot-password' element={<ForgotPasswordPage />} />
      <Route path='/reset-password' element={<ResetPasswordPage />} />
      <Route path='/order/:orderNo' element={<OrderDetailPage />} />
      <Route path='/ecatalog' element={<ECatalogPage />} />
      <Route path='/shopby' element={<ShopByPage />} />
    </Routes>
  );
};

export default AppRoutes;
